<template>
	<div class="m-table-index" id="table-w">
        <table id="table-head" :class="{isFixed: headerFixed}">
            <thead>
                <tr f-font-PFR s-cr="#999999" class="g-fs28 f-nowrap">
                    <th id="m-index-name"><div>指数名称</div></th>
                    <th v-for="(item, index) in tableHead" :key="item.name" @click="changeRank(index)">
                        <div class="m-head-rank">
                            {{item.name}}
                            <div class="m-rank-base" :class="{'m-rank-up': item.status === '2', 'm-rank-down': item.status === '1'}"></div>
                        </div>
                    </th>
                </tr>
            </thead>
        </table>
        <div class="null-block" v-show="headerFixed"></div>
        <section id="table-body">
            <table id="table1">
                <tfoot>
                    <tr 
                        v-for="(item, index) in currentList" 
                        :key="index"
                        @click="goFund(index, item.fundCode)"
                        :class="{'low-color': item.evaluateStatus === '0', 'middle-color': item.evaluateStatus === '1', 'high-color': item.evaluateStatus === '2'}"
                    >
                        <td :class="{'td-low-color': item.evaluateStatus === '0', 'td-middle-color': item.evaluateStatus === '1', 'td-high-color': item.evaluateStatus === '2'}">
                            <div class="m-tfoot-td">
                                <div class="m-tfoot-td-first f-ellipsis">{{item.name || item.fundName || '--'}}</div>
                                <div f-font-PFR s-cr="#666666" class="g-fs24 m-tfoot-td-second">
                                    <span s-cr="#FFFFFF" v-if="item.evaluateStatus" class="specical-color">{{status[item.evaluateStatus]}}</span>{{item.fundCode}}
                                </div>
                            </div>
                        </td>
                        <td>
                            <div class="m-tfoot-td">
                                <div class="m-tfoot-td-first">{{item.type}}</div>
                                <div class="m-tfoot-td-second"></div>
                            </div>
                        </td>
                        <td>
                            <div class="m-tfoot-td">
                                <div class="m-tfoot-td-first">{{item.pe | formatProfit(false, false, true)}}</div>
                                <div f-font-PFR s-cr="#666666" class="g-fs24 m-tfoot-td-second f-tc m-suit" v-if="item.applyArea === 'PE'">适用</div>
                                <div class="m-tfoot-td-second" v-else></div>
                            </div>
                        </td>
                        <td>
                            <div class="m-tfoot-td">
                                <div class="m-tfoot-td-first">{{item.pePercent | formatProfit(true, false, true)}}</div>
                                <div class="m-tfoot-td-second">
                                    <span class="m-table-progress">
                                        <em 
                                        :style="{width: `${item.pePercent}%`}"
                                        :class="{'low-color-em': item.pePercent <= 30, 'middle-color-em': item.pePercent > 30 && item.pePercent <= 70, 'high-color-em': item.pePercent > 70 && item.pePercent <= 100}">
                                        </em>
                                    </span>
                                </div>
                            </div>
                        </td>
                        <td>
                            <div class="m-tfoot-td">
                                <div class="m-tfoot-td-first">{{item.pb | formatProfit(false, false, true)}}</div>
                                <div f-font-PFR s-cr="#666666" class="g-fs24 m-tfoot-td-second f-tc m-suit" v-if="item.applyArea === 'PB'">适用</div>
                                <div class="m-tfoot-td-second" v-else></div>
                            </div>
                        </td>
                        <td>
                            <div class="m-tfoot-td">
                                <div class="m-tfoot-td-first">{{item.pbPercent | formatProfit(true, false, true)}}</div>
                                <div class="m-tfoot-td-second">
                                    <span class="m-table-progress">
                                        <em 
                                        :style="{width: `${item.pbPercent}%`}"
                                        :class="{'low-color-em': item.pbPercent <= 30, 'middle-color-em': item.pbPercent > 30 && item.pbPercent <= 70, 'high-color-em': item.pbPercent > 70 && item.pbPercent <= 100}">
                                        </em>
                                    </span>
                                </div>
                            </div>
                        </td>
                        <td>
                            <div class="m-tfoot-td">
                                <div class="m-tfoot-td-first">{{item.roe | formatProfit(true, false, true)}}</div>
                                <div class="m-tfoot-td-second"></div>
                            </div>
                        </td>
                        <td>
                            <div class="m-tfoot-td">
                                <div class="m-tfoot-td-first" :class="{red: item.weekRise > 0, green: item.weekRise < 0}">{{item.weekRise | formatProfit(true, true, true)}}</div>
                                <div class="m-tfoot-td-second"></div>
                            </div>
                        </td>
                        <td>
                            <div class="m-tfoot-td">
                                <div class="m-tfoot-td-first" :class="{red: item.nowYearRise > 0, green: item.nowYearRise < 0}">{{item.nowYearRise | formatProfit(true, true, true)}}</div>
                                <div class="m-tfoot-td-second"></div>
                            </div>
                        </td>
                    </tr>
                </tfoot>
            </table>
        </section>
        <div id="m-head-first" v-show="headerFixed">
            <span f-font-PFR s-cr="#999999" class="g-fs28">指数名称</span>
        </div>
	</div>
</template>

<script>
    import { config } from '@/assets/js/common';
    export default {
        name: "table",
        props: {
            allMeList: {
                type: Array,
                default: () => []
            },
            initAllMeList: {
                type: Array,
                default: () => []
            },
        },
        data () {
            return {
                tableHead: [{
                    name: '类型',
                    status: '0',
                    type: 'type'
                }, {
                    name: 'PE',
                    status: '0',
                    type: 'newpe'
                }, {
                    name: 'PE百分位',
                    status: '0',
                    type: 'pepercent'
                }, {
                    name: 'PB',
                    status: '0',
                    type: 'newpb'
                }, {
                    name: 'PB百分位',
                    status: '0',
                    type: 'pbpercent'
                }, {
                    name: 'ROE',
                    status: '0',
                    type: 'newroe'
                }, {
                    name: '近一周涨幅',
                    status: '0',
                    type: 'weekzhangfu'
                }, {
                    name: '今年来涨幅',
                    status: '0',
                    type: 'yearzhangfu'
                }],
                currentTab: 'pe',
                currentStatus: '0',
                status: {
                    '0': '较低',
                    '1': '适中',
                    '2': '较高'
                },
                currentList: [],
                headerFixed: false,
                first: false,
                obody: '',
                ohead: ''
			}
        },
        methods: {
            changeRank(index) {
                let obj = {...this.tableHead[index]};
                let type = '';
                let selectType = {
                    0: 'type',
                    1: 'pe',
                    2: 'pePercent',
                    3: 'pb',
                    4: 'pbPercent',
                    5: 'roe',
                    6: 'weekRise',
                    7: 'nowYearRise',
                }
                let key = selectType[index];
                this.tableHead.forEach((item, num) => {
                    if (index !== num) {
                        item.status = '0';
                    }
                })
                switch(obj.status) {
                    case '0':
                        obj.status = '2';
                        type = 'asc';
                        break;
                    case '1':
                        obj.status = '0';
                        type = 'moren';
                        break;
                    case '2':
                        obj.status = '1';
                        type = 'desc';
                        break;
                    default:
                        break;
                }
                this.currentTab = obj.type;
                this.currentStatus = obj.status;
                _.log().clickStat(`${obj.type}.${type}`);
                this.$set(this.tableHead, index, obj);
                if (obj.status === '0') {
                    this.currentList = [...this.initAllMeList];
                    return;
                }

                let hasData = [], noData = [], hasData1 = [], hasData2 = [];
                this.allMeList.forEach((item) => {
                    if (item[key] !== '' && item[key] !== null && item[key] !== undefined) {
                        if (index === 0) {
                            switch(item[key]) {
                                case '宽基':
                                    hasData.push(item);
                                    break;
                                case '行业':
                                    hasData1.push(item);
                                    break;
                                case '主题':
                                    hasData2.push(item);
                                    break;
                            }
                        } else {
                            hasData.push(item);
                        }
                        
                    }else {
                        noData.push(item);
                    }
                })
                if (hasData.length > 1 && index !== 0) {
                    hasData.sort((a, b) => {
                        if (type === 'asc') {
                            return a[key] - b[key]
                        } else {
                            return b[key] - a[key]
                        }
                    })
                }
                if (index !== 0) {
                    this.currentList = [...hasData, ...noData];
                } else {
                    if (type === 'asc') {
                        this.currentList = [...hasData1, ...hasData, ...hasData2, ...noData];
                    } else {
                        this.currentList = [...hasData2, ...hasData, ...hasData1, ...noData];
                    }
                }
            },
            goFund(index, code) {
                _.log().jumpPageStat(`${this.currentTab}.${this.currentStatus === '1' ? 'desc' : (this.currentStatus === '2' ? 'asc' : 'moren')}.${index+1}`, 'seat_null');

                let url = `https://${config.testDev ? 'test' : ''}fund.10jqka.com.cn/${_.urlInfo.sys === 'ths' ? 'scym_scsy' : 'ifundapp_app'}/public/sf/indexValuation/dist/detail$FF330A.html?code=${code}#/`;
				if (_.urlInfo.sys === 'ths') {
					location.href = `client.html?action=ymtz^url=${url}^webid=2804^mode=new`;
				} else {
					_ && _.jump().topage(url, '指数估值详情');
				}
            },
            handleScroll() {
                // 得到页面滚动的距离
                let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
                // 判断页面滚动的距离是否大于吸顶元素的位置
                this.headerFixed = scrollTop > this.offsetTop;
                if (this.headerFixed && !this.first) {
                    this.first = true;
                    this.bodyScroll();
                } else if (this.headerFixed === false && this.first) {
                    this.first = false;
                    if (!this.oheadth) {
                        this.oheadth = document.getElementById('m-index-name');
                    }
                    this.oheadth.style.left = '0px';
                    this.oheadth.style.backgroundColor = '#FFFFFF';
                }
            },
            bodyScroll() {
                if (this.headerFixed) {
                    if (!this.obody) {
                        this.obody = document.getElementById('table-w');
                    }
                    if (!this.ohead) {
                        this.ohead = document.getElementById('table-head');
                    }
                    if (!this.oheadth) {
                        this.oheadth = document.getElementById('m-index-name');
                    }

                    this.ohead.style.left = `-${this.obody.scrollLeft}px`;
                    this.oheadth.style.left = `-${this.obody.scrollLeft}px`;
                    this.oheadth.style.backgroundColor = 'transparent';
                }
                
            }
        },
        mounted() {
            // this.changeRank(2, false);
            this.currentList = [...this.initAllMeList];
            window.addEventListener('scroll', this.handleScroll);
            this.$nextTick(function(){
                let header = document.getElementById("table-head");
                // 这里要得到top的距离和元素自身的高度
                this.offsetTop = header.offsetTop;
                this.offsetHeight = header.offsetHeight;
                console.log(header.offsetHeight)
                
            });
            if (!this.obody) {
                this.obody = document.getElementById('table-w');
            }
            this.obody.addEventListener('scroll', this.bodyScroll);
        },
        destroyed(){
            window.removeEventListener('scroll', this.handleScroll);
            if (!this.obody) {
                this.obody = document.getElementById('table-w');
            }
            this.obody.removeEventListener('scroll', this.bodyScroll);
            
        },
    }
</script>

<style lang="less">
.m-table-index {
    overflow-x: auto;
    table {
        background: #ffffff;
        table-layout: fixed;
        thead {
            display: block;
            height: 88px;
            tr {
                display: inline-block;
                height: 88px;
                line-height: 88px;
                font-weight: 400;
                padding-right: 32px;
                th {
                    &:first-child {
                        padding-left: 32px;
                    }
                }
                th div {
                    box-sizing: border-box;
                    padding-right: 32px;
                    &.m-head-rank {
                        position: relative;
                        padding-right: 54px;
                        .m-rank-base {
                            position: absolute;
                            width: 14px;
                            height: 30px;
                            top: 50%;
                            right: 34px;
                            padding: 0;
                            background-image: url('../../assets/images/icon_t.png');
                            background-repeat: no-repeat;
                            background-size: 100% 100%;
                            transform: translateY(-50%);
                            &.m-rank-up {
                                background-image: url('../../assets/images/icon_t_up.png');
                            }
                            &.m-rank-down {
                                background-image: url('../../assets/images/icon_t_down.png');
                            }
                        }
                        // &::before {
                        //     content: '';
                        //     position: absolute;
                        //     top: 20px;
                        //     right: 32.5px;
                        //     width: 0;
                        //     height: 0;
                        //     border-width: 11px 8px;
                        //     border-style: solid;
                        //     border-color: transparent transparent #cccccc transparent;
                        // }
                        // &::after {
                        //     content: '';
                        //     position: absolute;
                        //     top: 48.5px;
                        //     right: 32.5px;
                        //     width: 0;
                        //     height: 0;
                        //     border-width: 11px 8px;
                        //     border-style: solid;
                        //     border-color: #cccccc transparent transparent transparent;
                        // }
                        // &.m-head-up {
                        //     &::before { 
                        //         border-bottom-color: #e93030;
                        //         right: 32px;
                        //     }
                        // }
                        // &.m-head-down {
                        //     &::after { 
                        //         border-top-color: #e93030;
                        //         right: 32px;
                        //     }
                        // }
                    }
                }
                th:last-child div.m-head-rank {
                    padding-right: 22px;
                    .m-rank-base {
                        right: 2px;
                    }
                    // &::before {
                    //     right: 0px;
                    // }
                    // &::after {
                    //     right: 0px;
                    // }
                }
            }
        }
        tfoot {
            display: block;
            tr {
                display: inline-block;
                box-sizing: border-box;
                padding-right: 32px;
                td {
                    padding-top: 24px;
                    &:first-child {
                        padding-left: 32px;
                        &.td-low-color {
                            background-color: #e8ffeb;
                        }
                        &.td-middle-color {
                            background-color: #fef8ea;
                        }
                        &.td-high-color {
                            background-color: #fff1ef;
                        }
                    }
                }
                td .m-tfoot-td{
                    border-bottom: 2px solid rgba(0, 0, 0, 0.04);
                    padding-bottom: 22px;
                    padding-right: 32px;
                    white-space: nowrap;
                    box-sizing: border-box;
                    .m-tfoot-td-first {
                        font-family: PingFangSC-Regular;
                        font-size: 28px;
                        color: #323232;
                        line-height: 40px;
                        font-weight: 400;
                        margin-bottom: 4px;
                        height: 40px;
                        &.red {
                            color: #FF330A;
                        }
                        &.green {
                            color: #00BB1D;
                        }
                    }
                    .m-tfoot-td-second {
                        height: 32px;
                        line-height: 32px;
                        font-weight: 400;
                        &.m-suit {
                            box-sizing: border-box;
                            width: 56px;
                            background: #F6F6F6;
                            border: 1px solid rgba(0, 0, 0, 0.04);
                            border-radius: 8px;
                            margin-left: 15px;
                            line-height: 30px;
                        }
                    }
                }
                td:last-child .m-tfoot-td {
                    padding-right: 0;
                }
                td:first-child .m-tfoot-td-second {
                    span {
                        display: inline-block;
                        padding: 0 4px;
                        height: 32px;
                        line-height: 32px;
                        border-radius: 8px;
                        margin-right: 8px;
                    }
                }
                
                &.low-color {
                    background-image: linear-gradient(270deg, rgba(230,255,234,0.00) 0%, #E6FFEA 100%);
                    .specical-color {
                        background: #00CC22;
                    }
                }
                &.middle-color {
                    background-image: linear-gradient(270deg, rgba(255,247,230,0.00) 0%, #FFF7E6 100%);
                    .specical-color {
                        background: #FFAA00;
                    }
                }
                &.high-color {
                    background-image: linear-gradient(270deg, rgba(255,238,235,0.00) 0%, #FFEEEB 100%);
                    .specical-color {
                        background: #FF330A;
                    }
                }
                .low-color-em {
                    background: #00CC22;
                }
                .middle-color-em {
                    background: #FFAA00;
                }
                .high-color-em {
                    background: #FF330A;
                }
            }
        }
        thead tr th, tfoot tr td {
            text-align: right;
        }
        thead tr th:first-child, tfoot tr td:first-child {
            position: sticky;
            left: 0px;
            top: 0px;
            background: #ffffff;
            z-index: 2;
        }
        thead tr th:first-child div, tfoot tr td:first-child .m-tfoot-td {
            width: 256px;
            text-align: left;
        }
        thead tr th:nth-child(2) div, tfoot tr td:nth-child(2) .m-tfoot-td {
            width: 120px;
        }
        thead tr th:nth-child(3) div, tfoot tr td:nth-child(3) .m-tfoot-td {
            width: 107px;
        }
        thead tr th:nth-child(4) div, tfoot tr td:nth-child(4) .m-tfoot-td {
            width: 192px;
        }
        thead tr th:nth-child(5) div, tfoot tr td:nth-child(5) .m-tfoot-td {
            width: 107px;
        }
        thead tr th:nth-child(6) div, tfoot tr td:nth-child(6) .m-tfoot-td {
            width: 192px;
        }
        thead tr th:nth-child(7) div, tfoot tr td:nth-child(7) .m-tfoot-td {
            width: 152px;
        }
        thead tr th:nth-child(8) div, tfoot tr td:nth-child(8) .m-tfoot-td {
            width: 204px;
        }
        thead tr th:nth-child(9) div, tfoot tr td:nth-child(9) .m-tfoot-td {
            width: 192px;
        }
    }
    .m-table-progress {
        position: relative;
        display: inline-block;
        width: 84px;
        height: 8px;
        background: rgba(0, 0, 0, 0.04);
        border-radius: 20px;
        em {
            position: absolute;
            top: 0; 
            left: 0;
            height: 8px;
            border-radius: 20px;
        }
    }
    .isFixed {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 5;
    }
    .null-block {
        width: 100%;
        height: 88px;
    }
    #m-head-first {
        position: fixed;
        top: 0;
        left: 0;
        width: 256px;
        text-align: left;
        padding-left: 32px;
        background: #FFFFFF;
        height: 88px;
        line-height: 88px;
        z-index: 8;
        span {
            display: block;
            box-sizing: border-box;
            padding-right: 32px;
        }
    }
}
</style>
